import { useContext } from "react";
import { authContext } from "./AuthContext";
import { RequiredLogin } from "../Pages/RequiredLogin";
import { Spinner } from "reactstrap";
import { Sidebar } from "../Components/SideBar";
import { HeaderComponent } from "../Components/HeaderComponent";

export const RequiredAuth = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useContext(authContext);

  if (loading) {
    return <div><Spinner /></div>;
  }

  if (!user) {
    return <RequiredLogin />;
  }

  return (
    <div className="d-flex flex-column">
      <HeaderComponent />
      <div className="d-flex gap-1 py-3 px-4 flex-1 justify-content-center" style={{ minHeight: "90vh" }}>
        <Sidebar />
        {children}
      </div>
      {/* <FooterComponent /> */}
    </div>);
};
